module.exports = __webpack_public_path__ + "static/media/down-chevron-white.4ad1f8d7.svg";